
import * as React from "react";
import type { NotificationContextType } from "../../types/notification.types";

export const NotificationContext = React.createContext<NotificationContextType | undefined>(undefined);